import { render, staticRenderFns } from "./Thyjl.vue?vue&type=template&id=07f2e80a&scoped=true"
import script from "./Thyjl.vue?vue&type=script&lang=js"
export * from "./Thyjl.vue?vue&type=script&lang=js"
import style0 from "./Thyjl.vue?vue&type=style&index=0&id=07f2e80a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f2e80a",
  null
  
)

export default component.exports